"use client";

import { useState } from "react";
import { Play } from "lucide-react";
import { DashboardPreview } from "./hero-preview";
import { useDataFastGoals } from "@/hooks/useDataFastGoals";

const VIDEO_ID = "CK4dsyQybfs";

export function HeroVideo() {
  const [playing, setPlaying] = useState(false);
  const { trackHeroVideoClicked } = useDataFastGoals();

  if (playing) {
    return (
      <div className="aspect-video w-full bg-foreground">
        <iframe
          className="h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${VIDEO_ID}?autoplay=1&rel=0`}
          title="Ecclesiato — Tour completo pelo sistema"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerPolicy="strict-origin-when-cross-origin"
          allowFullScreen
        />
      </div>
    );
  }

  return (
    <button
      type="button"
      onClick={() => {
        trackHeroVideoClicked();
        setPlaying(true);
      }}
      className="group relative block w-full cursor-pointer overflow-hidden text-left focus-visible:outline-2 focus-visible:-outline-offset-4 focus-visible:outline-ring"
      aria-label="Assistir ao tour em vídeo pelo sistema Ecclesiato (1 minuto)"
    >
      {/* Prévia com dados cheios do sistema. No mobile ela é recortada numa
          altura fixa com fade no rodapé: o dashboard é responsivo de verdade e
          empilha em coluna única, então sem o recorte o product shot ocuparia
          várias telas. Ajuste a altura pelo max-h (105 = 420px). */}
      <div className="pointer-events-none relative max-h-105 overflow-hidden select-none md:max-h-none md:overflow-visible">
        <DashboardPreview />
        <div className="absolute inset-x-0 bottom-0 h-16 bg-linear-to-t from-background to-transparent md:hidden" />
      </div>

      <div className="absolute inset-0 grid place-items-center bg-background/15 transition-colors duration-200 group-hover:bg-background/5">
        <span className="flex items-center gap-3 rounded-full bg-primary py-2 pr-5 pl-2 text-sm font-semibold text-primary-foreground shadow-xl transition-[scale] duration-200 ease-(--lp-ease-out) group-hover:scale-[1.03] group-active:scale-[0.96]">
          <span className="grid size-10 place-items-center rounded-full bg-primary-foreground/15">
            {/* Triângulo nudge de 1px à direita: o centro óptico do play não
                é o centro geométrico. */}
            <Play
              className="size-4 translate-x-px fill-current"
              aria-hidden="true"
            />
          </span>
          Assistir ao tour · 1 min
        </span>
      </div>
    </button>
  );
}
